<template>
    <div class="datetime px-2 tabular-nums">
        <div class="date title main--text">
            {{ currentTime | format_time }}
        </div>
        <div class="time overline main--text">
            {{ currentTime | format_date_friendly_no_year }}
        </div>
    </div>
</template>

<script>
import { onMounted, ref, onDeactivated } from "@vue/composition-api";
import {eventBus} from '../../main'
import {differenceInCalendarDays} from "date-fns"

export default {
    name: "AppToolbarDateTime",
    setup() {
        let currentTime = ref(new Date());
        let interval = null;

        onMounted(() => {
            interval = setInterval(function() {
                let currentDateTime = new Date()
                if (currentDateTime.getDate() !== currentTime.value.getDate()) {
                    let days = differenceInCalendarDays(currentDateTime, currentTime.value)
                    eventBus.$emit('day_changed', {days: days})
                }
                currentTime.value = currentDateTime;
            }, 5000);
        });

        onDeactivated(() => {
            clearInterval(interval);
        });

        return {
            currentTime
        };
    }
};
</script>

<style lang="scss" scoped>
.datetime {
    display: flex;
    flex-direction: column;
    min-width: 85px;
    height: 100%;
    text-align: center;
    background: var(--v-g3-base);
    padding-top: 8px;
}
.time {
    opacity: 0.5;
    line-height: 0.75rem !important;
}
</style>
